/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ITplArbetsorderDestineringDto } from "../components/tpl-karta/tpl-karta-models";
import { IKeyValue, ITplArbetsorder } from "../models/dtos";
import { ITplTransportforetagHandelssortimentDto, ITransportforetag } from "../models/queries";

export interface ITplState {
    name: string;
    showArbetsorderLegend: boolean;
    arbetsordrar: BehaviorSubject<ITplArbetsorder[]>;
    maskinlag: BehaviorSubject<IKeyValue[]>;
    filteredTransportforetag: BehaviorSubject<IKeyValue[]>;
    currentArbetsordrar: BehaviorSubject<ITplArbetsorder[]>;
    transportforetag: BehaviorSubject<ITransportforetag[]>;
    selected: BehaviorSubject<ITplSelected>;
    transportsatt: BehaviorSubject<ITplTransportsatt>;
    modifiedArbetsordrar: BehaviorSubject<ITplArbetsorder[]>;
    arbetsorderHandelssortiment: BehaviorSubject<ITplTransportforetagHandelssortimentDto[]>;
    arbetsordrarDestinering: BehaviorSubject<ITplArbetsorderDestineringDto[]>;
    destineringHs: BehaviorSubject<number>;
    selectedHs: BehaviorSubject<number[]>;
    selectedMottagningsplatser: BehaviorSubject<number[]>;
    selectedVaglager: BehaviorSubject<boolean>;
    selectedDestineringsomraden: BehaviorSubject<number[]>;

    setArbetsordrar(arbetsordrar: ITplArbetsorder[]): void;
    getArbetsordrar(): ITplArbetsorder[];
    setCurrentArbetsordrar(arbetsordrar: ITplArbetsorder[]);
    getCurrentArbetsordrar(): ITplArbetsorder[];
    setMaskinlag(maskinlag: IKeyValue[]);
    getMaskinlag(): IKeyValue[];
    setFilteredTransportforetag(transportforetag: IKeyValue[]);
    updateFilteredTransportforetag();
    getFilteredTransportforetag(): IKeyValue[];
    setTransportforetag(transportforetag: ITransportforetag[]): void;
    getTransportforetag(): ITransportforetag[];
    setTransportsatt(transportsatt: ITplTransportsatt);
    getTransportsatt(): ITplTransportsatt;
    setSelected(selected: ITplSelected);
    getSelected(): ITplSelected;
    addSelected(add: ITplSelected);
    removeSelected(remove: ITplSelected);
    setArbetsorderHandelssortiment(aohs: ITplTransportforetagHandelssortimentDto[]);
    getArbetsorderHandelssortiment(): ITplTransportforetagHandelssortimentDto[];
    modifyArbetsordrar(ao: ITplArbetsorder[]): void;
    setArbetsordrarDestinering(aodst: ITplArbetsorderDestineringDto[]);
    getArbetsordrarDestinering(): ITplArbetsorderDestineringDto[];
    setSelectedHandelssortiment(hs: number[]);
    getSelectedHandelssortiment(): number[];
    setDestineringHandelssortiment(hs: number);
    getDestineringHandelssortiment(): number;
    setSelectedMottagningsplatser(mpl: number[]);
    getSelectedMottagningsplatser(): number[];
    setSelectedVaglager(vaglager: boolean);
    getSelectedVaglager(): boolean;
    setSelectedDestineringsomraden(dso: number[]);
    getSelectedDestineringsomraden(): number[];
}

export interface ITplSelected {
    selected: number[];
    origin: string;
}

export interface ITplTransportsatt {
    rundvirke: boolean;
    bransle: boolean;
}

export class SharedState {
    arbetsordrar: BehaviorSubject<ITplArbetsorder[]> = new BehaviorSubject<ITplArbetsorder[]>([]);
    currentArbetsordrar: BehaviorSubject<ITplArbetsorder[]> = new BehaviorSubject<ITplArbetsorder[]>([]);
    maskinlag: BehaviorSubject<IKeyValue[]> = new BehaviorSubject<IKeyValue[]>([]);
    filteredTransportforetag: BehaviorSubject<IKeyValue[]> = new BehaviorSubject<IKeyValue[]>([]);
    transportforetag: BehaviorSubject<ITransportforetag[]> = new BehaviorSubject<ITransportforetag[]>([]);
    selected: BehaviorSubject<ITplSelected> = new BehaviorSubject<ITplSelected>({ selected: [],
        origin: "" });
    transportsatt: BehaviorSubject<ITplTransportsatt> = new BehaviorSubject<ITplTransportsatt>({ rundvirke: false,
        bransle: false });
    modifiedArbetsordrar: BehaviorSubject<ITplArbetsorder[]> = new BehaviorSubject<ITplArbetsorder[]>([]);
    arbetsorderHandelssortiment: BehaviorSubject<ITplTransportforetagHandelssortimentDto[]> = new BehaviorSubject<ITplTransportforetagHandelssortimentDto[]>([]);
    arbetsordrarDestinering: BehaviorSubject<ITplArbetsorderDestineringDto[]> = new BehaviorSubject<ITplArbetsorderDestineringDto[]>([]);
    selecedHs: BehaviorSubject<number[]> = new BehaviorSubject<number[]>(null);
    destineringHs: BehaviorSubject<number> = new BehaviorSubject<number>(null);
    selectedMottagningsplatser: BehaviorSubject<number[]> = new BehaviorSubject<number[]>(null);
    selectedVaglager: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    selectedDestineringsomraden: BehaviorSubject<number[]> = new BehaviorSubject<number[]>(null);
}

export class State implements ITplState {
    name: string;
    showArbetsorderLegend = false;
    private readonly shared: SharedState;

    constructor(name: string, sharedstate: SharedState, showLegend = false) {
        this.shared = sharedstate;
        this.name = name;
        this.showArbetsorderLegend = showLegend;
    }

    get arbetsordrar() { return this.shared.arbetsordrar; }
    get currentArbetsordrar() { return this.shared.currentArbetsordrar; }
    get maskinlag() { return this.shared.maskinlag; }
    get filteredTransportforetag() { return this.shared.filteredTransportforetag; }
    get transportforetag() { return this.shared.transportforetag; }
    get selected() { return this.shared.selected; }
    get transportsatt() { return this.shared.transportsatt; }
    get modifiedArbetsordrar() { return this.shared.modifiedArbetsordrar; }
    get arbetsorderHandelssortiment() { return this.shared.arbetsorderHandelssortiment; }
    get arbetsordrarDestinering() { return this.shared.arbetsordrarDestinering; }
    get destineringHs() { return this.shared.destineringHs; }
    get selectedHs() { return this.shared.selecedHs; }
    get selectedMottagningsplatser() { return this.shared.selectedMottagningsplatser; }
    get selectedVaglager() { return this.shared.selectedVaglager; }
    get selectedDestineringsomraden() { return this.shared.selectedDestineringsomraden; }

    setArbetsordrar(arbetsordrar: ITplArbetsorder[]): void {
        this.shared.arbetsordrar.next(arbetsordrar);
    }
    getArbetsordrar(): ITplArbetsorder[] {
        return this.shared.arbetsordrar.value;
    }
    setCurrentArbetsordrar(ao: ITplArbetsorder[]) {
        this.shared.currentArbetsordrar.next(ao);
    }
    getCurrentArbetsordrar(): ITplArbetsorder[] {
        return this.shared.currentArbetsordrar.value;
    }
    setMaskinlag(maskinlag: IKeyValue[]) {
        this.shared.maskinlag.next(maskinlag);
    }
    getMaskinlag(): IKeyValue[] {
        return this.shared.maskinlag.value;
    }
    setFilteredTransportforetag(transportforetag: IKeyValue[]) {
        this.shared.filteredTransportforetag.next(transportforetag);
    }
    updateFilteredTransportforetag() {
        const arbetsordrar = this.getArbetsordrar();
        const allTransportforetag = this.getTransportforetag();
        const transportforetag = [];
        const aohs = this.getArbetsorderHandelssortiment();
        const tfAoIds = _.uniq(arbetsordrar.filter(x => ObjectUtils.hasValue(x.transportforetagId)).map(x => x.transportforetagId));
        const tfHsIds = _.uniq(aohs.filter(x => ObjectUtils.hasValue(x.transportforetagId)).map(x => x.transportforetagId));
        const tfIds = _.uniq([
            ...tfAoIds,
            ...tfHsIds
        ]);

        tfIds.forEach((id: number) => {
            const tf = allTransportforetag.find(x => x.id === id);
            const tfName = ObjectUtils.stringHasValue(tf.huvudkod)
                ? `${tf.huvudkod} ${tf.namn}`
                : tf.namn;

            transportforetag.push({ key: id,
                value: tfName });

        });

        this.setFilteredTransportforetag(transportforetag);
    }
    getFilteredTransportforetag(): IKeyValue[] {
        return this.shared.filteredTransportforetag.value;
    }
    getTransportforetag(): ITransportforetag[] {
        return this.shared.transportforetag.value;
    }
    setTransportforetag(transportforetag: ITransportforetag[]) {
        this.shared.transportforetag.next(transportforetag);
    }
    setSelected(selected: ITplSelected) {
        this.shared.selected.next(selected);
    }
    getSelected(): ITplSelected {
        return this.shared.selected.value;
    }
    setTransportsatt(transportsatt: ITplTransportsatt) {
        this.shared.transportsatt.next(transportsatt);
    }
    getTransportsatt(): ITplTransportsatt {
        return this.shared.transportsatt.value;
    }
    modifyArbetsordrar(ao: ITplArbetsorder[]) {
        this.shared.modifiedArbetsordrar.next(ao);
    }
    getArbetsorderHandelssortiment(): ITplTransportforetagHandelssortimentDto[] {
        return this.shared.arbetsorderHandelssortiment.value;
    }
    setArbetsorderHandelssortiment(aohs: ITplTransportforetagHandelssortimentDto[]) {
        this.shared.arbetsorderHandelssortiment.next(aohs);
    }
    getArbetsordrarDestinering(): ITplArbetsorderDestineringDto[] {
        return this.shared.arbetsordrarDestinering.value;
    }
    setArbetsordrarDestinering(aodst: ITplArbetsorderDestineringDto[]) {
        this.shared.arbetsordrarDestinering.next(aodst);
    }
    setDestineringHandelssortiment(hs: number) {
        this.shared.destineringHs.next(hs);
    }
    getDestineringHandelssortiment(): number {
        return this.shared.destineringHs.value;
    }
    setSelectedHandelssortiment(hs: number[]) {
        this.shared.selecedHs.next(hs);
    }
    getSelectedHandelssortiment(): number[] {
        return this.shared.selecedHs.value;
    }
    setSelectedMottagningsplatser(mpl: number[]) {
        this.shared.selectedMottagningsplatser.next(mpl);
    }
    getSelectedMottagningsplatser(): number[] {
        return this.shared.selectedMottagningsplatser.value;
    }
    setSelectedVaglager(vl: boolean) {
        this.shared.selectedVaglager.next(vl);
    }
    getSelectedVaglager(): boolean {
        return this.shared.selectedVaglager.value;
    }
    setSelectedDestineringsomraden(mpl: number[]) {
        this.shared.selectedDestineringsomraden.next(mpl);
    }
    getSelectedDestineringsomraden(): number[] {
        return this.shared.selectedDestineringsomraden.value;
    }
    addSelected(add: ITplSelected): void {
        const newList = _.uniq((this.selected.value.selected || []).concat(add.selected || []));
        this.shared.selected.next({ selected: newList,
            origin: add.origin });
    }
    removeSelected(remove: ITplSelected): void {
        const current = ObjectUtils.deepCopy(this.selected.value.selected);
        _.remove(current, x => remove.selected.some(y => y === x));
        this.shared.selected.next({ selected: current,
            origin: remove.origin });
    }
}

export class TplTabId {
    static readonly search = "search";
    static readonly filter = "filter";
    static readonly transporttilldelning = "transporttilldelning";
    static readonly omdestinera = "omdestinera";
    static readonly hanteraao = "hanteraao";
    static readonly handelser = "handelser";
}
